// extracted by mini-css-extract-plugin
export default {"move__header":"MoveDialog_move__header__9IiZy","moveDialog_breadcrumb":"MoveDialog_moveDialog_breadcrumb__MmbEW font-sm-regular","move__content":"MoveDialog_move__content__ZMTco"};